import { writable, readable } from 'svelte/store';
import { browser } from '$app/environment'

export const project = writable()
export const authPage = writable('login')

export const projectToplists = writable([])
export const orgOperators = writable([])
export const orgCasinoGames = writable([])
export const orgGameProviders = writable([])

export const commercialToplists = writable([])

export const postData = writable({})
export const postUsers = writable({})
export const postCategories = writable({})

export const previewMode = writable(false)
export const previewSize = writable('small')
export const previewFullHeightMode = writable(false)
export const previewActiveModal = writable(false)

export const postOperators = writable([])
// testing persistent stores
// export const postOperators = writable(
//   browser && (localStorage.getItem("postOperators") || "lol")
// )
// postOperators.subscribe((val) => browser && (localStorage.postOperators = val))

export const translations = readable({
  "Sort": {
    "sv": "Sortera",
  },
  "Load more casinos": {
    "sv": "Ladda fler casinon"
  },
  "Visit casino": {
    "sv": "Till casinot"
  },
  "Visit": {
    "sv": "Besök"
  },
  "Proceed to": {
    "sv": "Vidare till"
  },
  "Hot!": {
    "sv": "Hett nu!"
  },
  "New!": {
    "sv": "Nytt!"
  },
  "Popular!": {
    "sv": "Populär!"
  },
  "Crispy!": {
    "sv": "Krispigt!"
  },
  "Remember that...": {
    "sv": "Tänk på att..."
  },
  "Did you know?": {
    "sv": "Visste du att?"
  },
  "Source": {
    "sv": "Källa"
  },
  "Read news": {
    "sv": "Läs nyheten"
  },
  "Read more": {
    "sv": "Läs mer"
  },
  "Found no posts": {
    "sv": "Fant inga artiklar"
  },
  "Last updated": {
    "sv": "Senast uppdaterad"
  },
  "Table of contents": {
    "sv": "Innehåll"
  },
  "Content editor": {
    "sv": "Innehållsansvarig"
  },
  "About": {
    "sv": "Om"
  },
  "Contact us": {
    "sv": "Kontakt oss"
  },
  "Contact": {
    "sv": "Kontakt"
  },
  "Page does not exist": {
    "sv": "Sidan finns ej"
  },
  "Oops.. something went wrong": {
    "sv": "Oops.. nu blev något fel"
  },
  "Search": {
    "sv": "Sök"
  },
  "Thank you for visiting": {
    "sv": "Takk för att du besökte"
  },
  "Click here": {
    "sv": "Klicka här"
  },
  "if you aren't forwarded to": {
    "sv": "om du inte skickas vidare till"
  },
  "Casino has english license": {
    "se": "Casinot har svensk licens",
    "ca": "Casino has canadian license"
  },
  "Casino open for english players": {
    "se": "Casinot öppen för svenska spelare",
    "ca": "Casino open for canadian players",
    "in": "Casino open for indian players"
  },
  "Our rating": {
    "sv": "Vårt betyg"
  },
  "English license": {
    "se": "Svensk licens",
    "ca": "Canadian license"
  },
  "Games offered": {
    "sv": "Spelutbud"
  },
  "Number of games": {
    "sv": "Antal spel"
  },
  "Support": {
    "sv": "Spelutbud"
  },
  "Tax free winnings": {
    "sv": "Skattefria vinster"
  },
  "License": {
    "sv": "Licens"
  },
  "Game providers": {
    "sv": "Spelleverantörer"
  },
  "Mobile casino": {
    "sv": "Mobilcasino"
  },
  "To": {
    "sv": "Till",
    "en": "To"
  },
  "Affiliate disclosure": {
    "sv": "Annonsinformation"
  },
  "No turnover": {
    "sv": "Utan omsättningskrav"
  },
  "Wagering req.": {
    "sv": "Oms.krav"
  },
  "No bonus": {
    "sv": "Inga bonus"
  },
  "No": {
    "sv": "Inga"
  },
  "Casino bonus": {
    "sv": "Casinobonus"
  },
  "Sports bonus": {
    "sv": "Sportbonus"
  },
  "Min. odds": {
    "sv": "Minsta odds"
  },
  "News": {
    "sv": "Nyheter"
  },
  "Archive": {
    "sv": "Arkiv"
  },
  "January": {
    "sv": "Januari"
  },
  "February": {
    "sv": "Februari"
  },
  "March": {
    "sv": "Mars"
  },
  "April": {
    "sv": "April"
  },
  "May": {
    "sv": "Maj"
  },
  "June": {
    "sv": "Juni"
  },
  "July": {
    "sv": "Juli"
  },
  "August": {
    "sv": "Augusti"
  },
  "September": {
    "sv": "September"
  },
  "October": {
    "sv": "Oktober"
  },
  "November": {
    "sv": "November"
  },
  "December": {
    "sv": "December"
  }
})